(function () {
  'use strict';

  // Temaet toggler kurv-skuffen ved hver opdatering, så vi åbner den kun, hvis den er lukket.
  // Tredje argument (rerender) er altid true, så skuffens varelinjer (antal, linjepris, total) tegnes om fra serveren.
  // Med false opdaterer temaet kun totalen, og antallet står forkert, til siden genindlæses.
  function cartUpdated() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var wasOpen = !!document.querySelector('.mini-cart--open');
      if (window.jQuery) { window.jQuery(document).trigger('theme:cart:updated', [cart, !wasOpen, true]); }
      return cart;
    });
  }

  document.addEventListener('click', function (e) {
    // Hurtigkøb på produktkort (kun produkter med én variant)
    var btn = e.target.closest('[data-lf-add]');
    if (btn) {
      e.preventDefault();
      var label = btn.getAttribute('data-label') || btn.textContent;
      btn.setAttribute('data-label', label);
      btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(btn.getAttribute('data-lf-add')), quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(cartUpdated)
        .then(function () {
          btn.classList.add('is-done'); btn.textContent = 'Lagt i kurv';
          setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; }, 1800);
        })
        .catch(function () {
          var card = btn.closest('.lf-card, .lf-mr__item');
          var a = card && card.querySelector('a.link, a.lf-mr__name');
          if (a) window.location.href = a.href;
        })
        .then(function () { btn.classList.remove('is-loading'); });
      return;
    }

    // Antal i kurv-skuffen: plus og minus på en varelinje
    var q = e.target.closest('[data-lf-qty]');
    if (q) {
      e.preventDefault();
      var box = q.closest('.lf-qty');
      var next = Number(box.getAttribute('data-qty')) + Number(q.getAttribute('data-lf-qty'));
      if (next < 1) return;
      box.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(box.getAttribute('data-line')), quantity: next })
      })
        .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
        .then(cartUpdated)
        .catch(function () { box.classList.remove('is-busy'); });
      return;
    }

    // Hele rutinen i kurven
    var rt = e.target.closest('[data-lf-routine]');
    if (rt) {
      e.preventDefault();
      var ids = rt.getAttribute('data-lf-routine').split(',').filter(Boolean);
      var text = rt.textContent;
      rt.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(cartUpdated)
        .then(function () { rt.textContent = 'Lagt i kurven'; setTimeout(function () { rt.textContent = text; }, 2200); })
        .catch(function () { rt.textContent = 'Noget gik galt, prøv igen'; setTimeout(function () { rt.textContent = text; }, 2500); })
        .then(function () { rt.disabled = false; });
    }
  });

  // Kurv-skuffen: anbefalinger (først ofte købt sammen, ellers lignende produkter)
  function fetchRecs(url) {
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.lf-minirecs');
        return src && src.querySelector('.lf-mr__item') ? src : null;
      })
      .catch(function () { return null; });
  }

  function loadMiniRecs() {
    document.querySelectorAll('.lf-minirecs[data-url]:not([data-loaded])').forEach(function (el) {
      el.setAttribute('data-loaded', '1');
      var base = el.getAttribute('data-url');
      fetchRecs(base + '&intent=complementary').then(function (src) {
        if (src) return { src: src, kind: 'complementary' };
        return fetchRecs(base + '&intent=related').then(function (rel) { return rel ? { src: rel, kind: 'related' } : null; });
      }).then(function (res) {
        if (!res) return;
        el.innerHTML = res.src.innerHTML;
        var title = el.querySelector('.lf-mr__title');
        var label = res.src.getAttribute(res.kind === 'complementary' ? 'data-title-complementary' : 'data-title-related');
        if (title && label) title.textContent = label;
      });
    });
  }

  // Skuffens indhold udskiftes, når kurven ændres, så vi lytter på ændringer i siden
  function initMiniRecs() {
    loadMiniRecs();
    if (window.MutationObserver) {
      new MutationObserver(loadMiniRecs).observe(document.body, { childList: true, subtree: true });
    }
  }

  // Hovedmenu: åbner ved hover (mus) eller klik, lukker ved klik udenfor eller Escape
  function initNav() {
    var items = document.querySelectorAll('.lf-dd');
    if (!items.length) return;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    function closeAll(except) { items.forEach(function (o) { if (o !== except) o.open = false; }); }
    items.forEach(function (d) {
      var timer;
      d.addEventListener('toggle', function () { if (d.open) closeAll(d); });
      if (canHover) {
        var host = d.parentNode;
        host.addEventListener('mouseenter', function () { clearTimeout(timer); d.open = true; });
        host.addEventListener('mouseleave', function () { timer = setTimeout(function () { d.open = false; }, 250); });
      }
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.lf-dd')) closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  // Sticky køb-knap på mobil, når den rigtige knap er ude af syne.
  // Produkter med varianter: knappen fører til valget af variant i stedet for at lægge en tilfældig variant i kurven.
  function initSticky() {
    var bar = document.querySelector('.lf-sticky');
    var atc = document.querySelector('.product__add-to-cart');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    var priceEl = document.querySelector('.product__details .product__price');
    var out = bar.querySelector('.lf-sticky__price');
    var go = bar.querySelector('.lf-sticky__go');
    var hasOptions = !!document.querySelector('.product__variants .single-option-selector');
    if (atc.disabled) { go.disabled = true; go.textContent = atc.textContent; }
    else if (hasOptions) { go.textContent = 'Vælg variant'; }
    go.addEventListener('click', function () {
      if (hasOptions && !atc.disabled) {
        var target = document.querySelector('.product__variants') || atc;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        atc.click();
      }
    });
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var below = en.boundingClientRect.top > 0;
      if (priceEl && out) out.textContent = priceEl.textContent.trim();
      bar.classList.toggle('is-visible', !en.isIntersecting && !below);
    }, { threshold: 0 }).observe(atc);
  }

  // Kategoribeskrivelse: vis de første linjer, resten bag "Læs mere"
  function initClamp() {
    document.querySelectorAll('[data-lf-clamp]').forEach(function (el) {
      if (el.scrollHeight <= el.clientHeight + 4 && el.textContent.length < 260) return;
      el.classList.add('is-clamped');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lf-coll-more';
      btn.textContent = 'Læs mere';
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-clamped');
        btn.textContent = open ? 'Læs mere' : 'Vis mindre';
      });
      el.parentNode.insertBefore(btn, el.nextSibling);
    });
  }

  // Afslør sektioner når de scrolles ind i billedet
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }

  function init() { initNav(); initSticky(); initClamp(); initReveal(); initMiniRecs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();